import Vue from 'vue';

import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      reportTypes: [],
      reportTypeDetails: {},

      editReportTypeDescriptor: false,
      editReportTypeType: false,

      showCreateReportTypeModal: false,
      createReportTypeInputs: { conditions: {}, },
    },

    getters: {

    },

    actions: {
      async listReportTypes({ commit, dispatch, }, params = {}) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const result = await app.service('report-types').find(params);
          commit('setReportTypes', result);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async getReportTypeDetails({ commit, dispatch, }, { id, params, }) {
        commit('setError', {});
        commit('setReportTypeDetails', {});
        commit('setEditReportTypeDescriptor', false);
        commit('setEditReportTypeType', false);
        const actionId = await dispatch('addPendingAction');

        try {
          const result = await app.service('report-types').get(id, params);

          result.reportBlocks = result.reportBlocks.sort(({ index: a, }, { index: b, }) => a - b);

          commit('setReportTypeDetails', result);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async patchReportType({ commit, dispatch, state, }, data) {
        const id = state.reportTypeDetails.id;
        if (!id) {
          throw new Error('Invalid reportType in state');
        }

        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          await app.service('report-types').patch(id, data);
          return dispatch('getReportTypeDetails', { id, });
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async createReportType({ commit, dispatch, state, }) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const { descriptor, type, conditions, } = state.createReportTypeInputs;

          if (!descriptor || !type) {
            throw new Error('Missing name or type');
          }

          const result = await app.service('report-types').create({ descriptor, type, conditions, });
          commit('setShowCreateReportTypeModal', false);

          commit('updateCreateReportTypeInputs', { descriptor: undefined, type: undefined, conditions: {}, });

          await dispatch('listReportTypes');

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async removeReportType({ commit, dispatch, state, }, id) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          await app.service('report-types').remove(id);
          return dispatch('listReportTypes');
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },
    },
    mutations: {
      setReportTypes: (state, reportTypes) => state.reportTypes = reportTypes,
      setReportTypeDetails: (state, reportTypeDetails) => state.reportTypeDetails = reportTypeDetails,
      setEditReportTypeDescriptor: (state, editReportTypeDescriptor) => state.editReportTypeDescriptor = editReportTypeDescriptor,
      setEditReportTypeType: (state, editReportTypeType) => state.editReportTypeType = editReportTypeType,

      setShowCreateReportTypeModal: (state, showCreateReportTypeModal) => state.showCreateReportTypeModal = showCreateReportTypeModal,
      clearCreateReportTypeInputs: state => state.createReportTypeInputs = { conditions: {}, },
      updateCreateReportTypeInputs: (state, data) => Object.keys(data).forEach(key => Vue.set(state.createReportTypeInputs, key, data[key])),
    },
  };
}
